<script lang="ts">
    import Time from './Time.svelte';
    import { Const } from '../../stores/Const';
    import { z } from 'zod';
    import { onMount } from 'svelte';
    import { debug } from '../../stores/store';

    export let seconds: number | null = null;
    export let warningAbove: number | null = Const.WORK_DAY_DURATION_SECONDS;
    export let warningBelow: number | null = 0;
    export let errorAbove: number | null = warningAbove;
    export let errorBelow: number | null = warningBelow;
    export let showSign: boolean = false;
    export let showExclamation: boolean = false;
    export let compare: number | null = null;
    export let estimation: boolean = false;
    export let displayFormat: 'duration' | 'time' = 'duration';
    export let title: string = '';
    export let noColors: boolean = false;
    export let flexDirection: 'row' | 'column' = 'row';
    export let bold: boolean = true;

    let warning: number = 0;
    let output: string = '';
    let diff: string | null = null;
    let prefix: string = '';

    let formatTime = function (seconds: number, showSign: boolean = false): string {
        if (z.coerce.number().safeParse(seconds).success === false) {
            return '--:--';
        }
        let minutes = Math.floor(Math.abs(seconds) / 60);
        let hours = Math.floor(minutes / 60);
        minutes = minutes % 60;
        return (
            (seconds < 0 ? '-' : showSign ? '+' : '') +
            `${hours}:${minutes.toString().padStart(2, '0')}`
        );
    };

    if (z.coerce.number().safeParse(seconds).success === false) {
        seconds = null;
    }

    // if (displayFormat === 'time' && seconds !== null) {
    //     // while (seconds > 86400) {
    //     //     seconds = seconds - 86400;
    //     // }
    // }

    $: {
        if ($debug) seconds = 1234567;
    }

    $: {
        if (z.coerce.number().safeParse(seconds).success === false) {
            seconds = null;
        }
        if (seconds !== null) {
            // output = formatTime(seconds, showSign);
            if (compare !== null && seconds != compare) {
                diff = formatTime(seconds - compare, true);
            } else {
                diff = null;
            }
        }
    }

    $: {
        warning = 0;
        if (seconds !== null) {
            if (errorAbove !== null && seconds > errorAbove) {
                warning = 2;
            } else if (warningAbove !== null && seconds > warningAbove) {
                warning = 1;
            } else if (errorBelow !== null && seconds < errorBelow) {
                warning = -2;
            } else if (warningBelow !== null && seconds < warningBelow) {
                warning = -1;
            }
        }
    }

    $: {
        estimation = estimation;
        // prefix = estimation ? `.. ` : ``;
        prefix = estimation ? `` : ``;
    }

    // prefix = estimation ? `.. ` : ``;
    prefix = estimation ? `` : ``;
</script>

<div class="duration-component" class:estimation class:noColors {title}>
    {#if seconds === null}
        <span class:bold class="dont-break"><Time seconds={null} {displayFormat} /></span>
    {:else}
        <div style="display: flex; flex-direction: {flexDirection}; column-gap: 5px;">
            <div class="dont-break" style={flexDirection === 'column' ? 'margin-bottom: 0;' : ''}>
                {#if warning !== 0}
                    <div
                        class:bold
                        class=" {Math.abs(warning) === 2 ? 'error' : 'warning'} dont-break"
                    >
                        <Time {seconds} {displayFormat} {prefix} />
                    </div>
                {:else}
                    <div class:bold>
                        <Time {seconds} {displayFormat} {prefix} />
                    </div>
                {/if}
                <div
                    class:bold
                    class=" {Math.abs(warning) === 2 ? 'error' : 'warning'} dont-break"
                    class:nonvisible={!warning}
                >
                    {showExclamation ? '!' : ''}
                </div>
            </div>
            {#if compare !== null && flexDirection === 'row'}
                <div
                    class="difference"
                    class:empty={!diff}
                    class:improvement={diff && diff.charAt(0) === '-'}
                >
                    ({diff})
                </div>
            {/if}
            {#if compare !== null && flexDirection === 'column'}
                <div
                    class="difference difference-column"
                    style="margin-top: -2px;"
                    class:empty={!diff}
                    class:improvement={diff && diff.charAt(0) === '-'}
                    class:noColors
                >
                    <Time seconds={seconds - compare} {displayFormat} showSign={true} />
                </div>
            {/if}
        </div>
    {/if}
</div>

<style>
    .duration-component {
        display: flex;
        align-items: center;
        column-gap: 3px;
        font-weight: 400;
        justify-content: flex-end;
    }
    .bold {
        font-weight: 500;
    }
    .nonvisible {
        display: none;
    }
    .nonvisible:last-child {
        visibility: hidden;
    }
    .empty {
        display: none;
    }
    .difference {
        color: var(--automapa-red);
    }
    .difference.improvement {
        color: var(--automapa-green-dark);
    }
    .difference-column {
        font-size: 12px;
        color: var(--planning-page-accent-color);
    }
    .difference-column.noColors {
        opacity: 0.5;
    }
    .difference-column.improvement {
        color: var(--planning-page-accent-color);
    }
    .estimation {
        opacity: 0.5;
        font-weight: 400;
    }
    .noColors .difference,
    .noColors .difference.improvement {
        color: currentColor;
    }
</style>
